var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "298",
        height: "298",
        viewBox: "0 0 298 298",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M242.894 57.1385C241.349 55.479 239.707 53.9127 237.977 52.448C223.011 39.7591 199.177 32.5297 178.973 38.8175C166.94 42.5603 159.013 52.9784 148.75 59.9218C135.84 68.6532 118.95 71.6332 103.74 74.9291C83.2195 79.3753 64.213 85.1803 52.1858 102.017C42.1908 116.017 39.2287 134.428 48.0495 149.101C56.4412 163.036 69.6903 174.938 84.03 183.783C96.3672 191.393 109.211 193.777 122.657 185.797C131.442 180.582 137.986 172.828 144.709 165.473C152.302 157.129 161.993 146.825 174.032 144.286C185.487 141.866 197.789 146.229 209.363 145.537C228.489 144.399 245.886 131.49 253.133 115.141C261.727 95.7235 257.293 72.6107 242.894 57.1385Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.9",
          d:
            "M242.894 57.1385C241.349 55.479 239.707 53.9127 237.977 52.448C223.011 39.7591 199.177 32.5297 178.973 38.8175C166.94 42.5603 159.013 52.9784 148.75 59.9218C135.84 68.6532 118.95 71.6332 103.74 74.9291C83.2195 79.3753 64.213 85.1803 52.1858 102.017C42.1908 116.017 39.2287 134.428 48.0495 149.101C56.4412 163.036 69.6903 174.938 84.03 183.783C96.3672 191.393 109.211 193.777 122.657 185.797C131.442 180.582 137.986 172.828 144.709 165.473C152.302 157.129 161.993 146.825 174.032 144.286C185.487 141.866 197.789 146.229 209.363 145.537C228.489 144.399 245.886 131.49 253.133 115.141C261.727 95.7235 257.293 72.6107 242.894 57.1385Z",
          fill: "white"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M149 254.826C212.821 254.826 264.558 251.805 264.558 248.079C264.558 244.353 212.821 241.332 149 241.332C85.1788 241.332 33.4416 244.353 33.4416 248.079C33.4416 251.805 85.1788 254.826 149 254.826Z",
          fill: "#F5F5F5"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M176.201 87.0159L177.769 88.1424C178.313 88.5397 178.862 88.9152 179.414 89.2688C180.516 90.0019 181.625 90.735 182.746 91.4025C183.866 92.07 184.998 92.7018 186.119 93.262C187.169 93.7915 188.257 94.2437 189.373 94.6149C189.126 94.5536 188.868 94.5415 188.616 94.5792C188.465 94.5976 188.319 94.6399 188.181 94.7043C188.008 94.7937 188.062 94.7997 188.151 94.7461C188.496 94.5071 188.807 94.2224 189.075 93.8997C189.859 92.9636 190.569 91.9672 191.197 90.9197C191.894 89.8231 192.562 88.6609 193.199 87.4689C193.837 86.2769 194.475 85.0551 195.065 83.8929L195.107 83.8154C195.409 83.2212 195.921 82.7606 196.544 82.5236C197.167 82.2866 197.856 82.2901 198.477 82.5335C199.097 82.7768 199.605 83.2425 199.901 83.8398C200.197 84.4371 200.26 85.1232 200.077 85.7643C199.267 88.604 198.241 91.3775 197.008 94.0607C196.339 95.5044 195.552 96.8899 194.654 98.2029C194.092 99.0164 193.433 99.7589 192.693 100.414C192.151 100.886 191.537 101.268 190.875 101.546C190.409 101.738 189.92 101.868 189.421 101.934C188.823 102.002 188.219 101.967 187.633 101.833C186.041 101.463 184.482 100.963 182.972 100.337C181.559 99.7616 180.179 99.111 178.836 98.3876C177.513 97.6843 176.223 96.9433 174.968 96.1645C174.342 95.7712 173.722 95.3719 173.108 94.9725C172.494 94.5732 171.916 94.156 171.243 93.6673C170.49 92.9735 170.019 92.0274 169.919 91.0088C169.818 89.9902 170.096 88.9703 170.699 88.1431C171.302 87.3159 172.187 86.7392 173.188 86.5225C174.188 86.3059 175.233 86.4645 176.124 86.9683L176.201 87.0159Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d:
            "M176.201 87.0159L177.769 88.1424C178.313 88.5397 178.862 88.9152 179.414 89.2688C180.516 90.0019 181.625 90.735 182.746 91.4025C183.866 92.07 184.998 92.7018 186.119 93.262C187.169 93.7915 188.257 94.2437 189.373 94.6149C189.126 94.5536 188.868 94.5415 188.616 94.5792C188.465 94.5976 188.319 94.6399 188.181 94.7043C188.008 94.7937 188.062 94.7997 188.151 94.7461C188.496 94.5071 188.807 94.2224 189.075 93.8997C189.859 92.9636 190.569 91.9672 191.197 90.9197C191.894 89.8231 192.562 88.6609 193.199 87.4689C193.837 86.2769 194.475 85.0551 195.065 83.8929L195.107 83.8154C195.409 83.2212 195.921 82.7606 196.544 82.5236C197.167 82.2866 197.856 82.2901 198.477 82.5335C199.097 82.7768 199.605 83.2425 199.901 83.8398C200.197 84.4371 200.26 85.1232 200.077 85.7643C199.267 88.604 198.241 91.3775 197.008 94.0607C196.339 95.5044 195.552 96.8899 194.654 98.2029C194.092 99.0164 193.433 99.7589 192.693 100.414C192.151 100.886 191.537 101.268 190.875 101.546C190.409 101.738 189.92 101.868 189.421 101.934C188.823 102.002 188.219 101.967 187.633 101.833C186.041 101.463 184.482 100.963 182.972 100.337C181.559 99.7616 180.179 99.111 178.836 98.3876C177.513 97.6843 176.223 96.9433 174.968 96.1645C174.342 95.7712 173.722 95.3719 173.108 94.9725C172.494 94.5732 171.916 94.156 171.243 93.6673C170.49 92.9735 170.019 92.0274 169.919 91.0088C169.818 89.9902 170.096 88.9703 170.699 88.1431C171.302 87.3159 172.187 86.7392 173.188 86.5225C174.188 86.3059 175.233 86.4645 176.124 86.9683L176.201 87.0159Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M196.567 82.7784L198.182 80.0487L201.281 83.3923C200.833 84.3633 200.025 85.122 199.028 85.5081C198.804 85.5844 198.566 85.608 198.331 85.577C198.096 85.546 197.872 85.4612 197.675 85.3293L197.079 84.9478C196.731 84.7213 196.484 84.3696 196.389 83.9657C196.293 83.5618 196.357 83.1366 196.567 82.7784Z",
          fill: "#FFB573"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M202.574 78.4217L203.26 78.8448C203.475 78.9779 203.656 79.1595 203.788 79.3749C203.92 79.5904 204 79.8338 204.022 80.0857C204.043 80.3376 204.005 80.5911 203.911 80.8258C203.817 81.0605 203.67 81.2699 203.48 81.4374L201.281 83.3923L198.182 80.0488L200.882 78.4157C201.137 78.26 201.43 78.1782 201.729 78.1792C202.028 78.1803 202.32 78.2642 202.574 78.4217Z",
          fill: "#FFB573"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M138.284 243.239L143.004 243.377L144.78 232.446L140.066 232.309L138.284 243.239Z",
          fill: "#FFB573"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M143.749 242.048L138.475 241.38C138.386 241.366 138.296 241.388 138.223 241.44C138.151 241.493 138.102 241.572 138.087 241.66L137.306 245.796C137.278 246.015 137.337 246.237 137.471 246.412C137.605 246.587 137.803 246.702 138.022 246.732C139.863 246.935 140.751 246.935 143.07 247.227C144.494 247.412 148.207 248.306 150.18 248.061C152.153 247.817 151.855 245.88 150.997 245.808C147.152 245.475 145.71 243.645 144.518 242.435C144.311 242.225 144.041 242.089 143.749 242.048Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d:
            "M140.06 232.315L144.78 232.452L143.862 238.084L139.142 237.947L140.06 232.315Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M165.861 127.544C165.861 127.544 161.742 166.636 159.001 179.915C156.021 194.457 146.384 236.999 146.384 236.999L137.747 236.362C137.747 236.362 142.48 192.353 146.354 178.109C146.354 163.316 149.93 121.858 149.93 121.858L165.861 127.544Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.3",
          d:
            "M152.099 140.757C152.022 137.7 150.365 136.716 148.732 136.752C148.136 144.107 147.498 153.124 147.015 161.26C149.912 156.563 152.314 149.25 152.099 140.757Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M137.491 236.421L146.741 237.107L147.802 233.62L137.152 233.513L137.491 236.421Z",
          fill: "white"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M90.4192 206.603L93.3932 210.281L102.291 203.862L99.3115 200.19L90.4192 206.603Z",
          fill: "#FFB573"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M94.0369 210.287L91.3906 205.68C91.3488 205.601 91.278 205.543 91.1933 205.516C91.1086 205.489 91.0169 205.496 90.9377 205.537L87.165 207.408C86.9736 207.517 86.8329 207.697 86.7738 207.909C86.7146 208.121 86.7417 208.348 86.8491 208.54C87.7968 210.132 88.3332 210.841 89.4954 212.867C90.2106 214.113 92.0939 217.695 93.0714 219.423C94.0488 221.152 95.7355 220.121 95.4554 219.304C94.2634 215.633 93.9236 212.826 94.168 211.151C94.2225 210.856 94.1763 210.552 94.0369 210.287Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d:
            "M99.3115 200.19L102.291 203.868L97.7023 207.17L94.7223 203.498L99.3115 200.19Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M157.249 124.183C157.249 124.183 145.633 157.427 140.352 169.92C134.577 183.598 100.039 207.891 100.039 207.891L94.5852 201.162C94.5852 201.162 118.056 177.638 126.769 166.481C131.597 151.289 141.902 118.693 141.902 118.693L157.249 124.183Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M94.3647 200.888L100.259 208.159L103.138 206.496L96.2361 198.796L94.3647 200.888Z",
          fill: "white"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M165.813 127.77L141.878 118.693C142.474 116.506 145.603 110.081 148.386 101.135C150.491 94.5246 152.022 87.7448 152.963 80.8712C152.988 80.6709 153.053 80.4776 153.155 80.3032C153.256 80.1288 153.392 79.977 153.555 79.8571C153.717 79.7371 153.902 79.6516 154.099 79.6056C154.295 79.5597 154.499 79.5543 154.698 79.5898C155.145 79.6673 155.675 79.7686 156.259 79.8819C157.767 80.1858 159.651 80.6149 161.444 81.1633C164.888 82.1727 168.271 83.3786 171.576 84.775C172.684 85.2734 173.76 85.8366 174.801 86.4617C175.42 86.8143 175.995 87.2405 176.511 87.7312C176.698 87.8811 176.853 88.067 176.967 88.2779C177.08 88.4888 177.151 88.7204 177.173 88.9589C177.173 92.38 173.746 105.635 165.813 127.77Z",
          fill: "#F0F0F0"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M171.1 84.5545C168.406 82.8023 168.537 80.7997 169.449 78.8687C169.678 78.3912 169.934 77.9275 170.218 77.48L167.625 73.0994L165.718 69.887C165.301 73.4153 164.025 79.6614 161.045 81.0441C162.674 83.3436 165 85.0573 167.679 85.9313C172.077 87.3021 171.1 84.5545 171.1 84.5545Z",
          fill: "#FFB573"
        }
      }),
      _c("path", {
        attrs: {
          d: "M167.512 85.8597L167.47 84.7393L164.49 85.3233L167.512 85.8597Z",
          fill: "#E0E0E0"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M167.512 85.8598L168.066 84.9479L169.991 87.2902L167.512 85.8598Z",
          fill: "#E0E0E0"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M161.45 80.5077C163.263 82.1756 165.287 83.5982 167.47 84.7393C166.278 85.4723 165.146 87.4034 164.717 89.0007C163.751 88.3272 159.889 81.9738 159.353 80.2275L161.45 80.5077Z",
          fill: "white"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M170.539 83.875C169.834 84.4641 168.973 84.8367 168.06 84.9478C168.698 85.8835 169.252 88.3092 169.252 89.7158C170.367 88.9887 172.089 86.4497 172.363 85.2994L170.539 83.875Z",
          fill: "white"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.3",
          d:
            "M170.635 83.7916C170.635 83.7916 173.239 85.0432 175.54 86.4617C176.482 87.0428 177.211 87.9144 177.615 88.9453C178.019 89.9762 178.077 91.1105 177.781 92.1774C174.938 102.226 171.1 111.982 169.508 117.412C167.822 123.199 165.473 130.458 165.473 130.458L161.415 131.418C161.415 131.418 171.588 92.5051 170.635 83.7916Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.3",
          d:
            "M161.391 80.0547C161.391 80.0547 157.892 79.5958 154.835 79.4587C153.763 79.4104 152.707 79.7332 151.845 80.3726C150.983 81.0121 150.367 81.9291 150.103 82.9691C148.553 89.096 147.409 100.813 145.841 105.373C143.892 111.071 141.252 122.18 141.252 122.18L155.115 130.19C155.115 130.19 169.121 87.165 161.391 80.0547Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M161.391 80.0547C161.391 80.0547 157.892 79.5958 154.835 79.4587C153.763 79.4104 152.707 79.7332 151.845 80.3726C150.983 81.0121 150.367 81.9291 150.103 82.9691C148.553 89.096 146.443 100.539 144.87 105.105C142.909 110.802 138.749 120.487 138.749 120.487L156.235 128.688C156.235 128.688 169.121 87.165 161.391 80.0547Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d:
            "M161.391 80.0547C161.391 80.0547 157.892 79.5958 154.835 79.4587C153.763 79.4104 152.707 79.7332 151.845 80.3726C150.983 81.0121 150.367 81.9291 150.103 82.9691C148.553 89.096 146.443 100.539 144.87 105.105C142.909 110.802 138.749 120.487 138.749 120.487L156.235 128.688C156.235 128.688 169.121 87.165 161.391 80.0547Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M170.635 83.7916C170.635 83.7916 173.239 85.0432 175.54 86.4617C176.482 87.0428 177.211 87.9144 177.615 88.9453C178.019 89.9762 178.077 91.1105 177.781 92.1774C174.938 102.226 172.691 112.757 171.559 118.3C170.367 124.2 169.121 129.57 169.121 129.57L162.565 130.458C162.565 130.458 171.588 92.5051 170.635 83.7916Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d:
            "M170.635 83.7916C170.635 83.7916 173.239 85.0432 175.54 86.4617C176.482 87.0428 177.211 87.9144 177.615 88.9453C178.019 89.9762 178.077 91.1105 177.781 92.1774C174.938 102.226 172.691 112.757 171.559 118.3C170.367 124.2 169.121 129.57 169.121 129.57L162.565 130.458C162.565 130.458 171.588 92.5051 170.635 83.7916Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d:
            "M170.218 77.48C169.934 77.9332 169.677 78.4029 169.449 78.8865C168.173 78.1177 166.862 75.9959 167.172 74.5238C167.269 74.0336 167.421 73.5558 167.625 73.0994L170.218 77.48Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M173.895 59.4093C177.066 59.8205 178.228 64.0998 176.476 66.9249C173.603 62.7588 173.895 59.4093 173.895 59.4093Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M164.025 67.3003C165.098 71.8836 165.485 74.6132 168.233 76.6694C169.118 77.3482 170.173 77.7718 171.281 77.8944C172.39 78.017 173.512 77.8339 174.524 77.3649C175.536 76.8959 176.401 76.1588 177.024 75.2336C177.648 74.3084 178.006 73.2303 178.061 72.116C178.359 67.8308 176.559 61.0542 171.702 59.8265C170.657 59.5317 169.553 59.5171 168.5 59.7842C167.448 60.0513 166.484 60.5906 165.706 61.348C164.929 62.1054 164.364 63.0541 164.069 64.0989C163.773 65.1438 163.758 66.2479 164.025 67.3003Z",
          fill: "#FFB573"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M165.438 71.3829C168.197 71.4604 167.768 66.8891 166.564 65.1607C170.39 65.7567 176.732 62.3773 177.37 58.8371C178.293 53.7055 170.468 53.7055 167.935 55.3386C169.026 55.4161 169.58 56.3399 169.318 56.8167C169.318 56.8167 165.539 55.6723 163.095 57.0014C164.162 57.3948 165.295 58.9325 161.236 59.4212C157.374 59.8861 158.542 63.772 160.491 63.7005C159.454 65.2918 158.208 68.9095 160.545 70.4472C162.881 71.9849 164.478 73.9874 163.972 74.8099C164.788 74.7801 166.522 73.7967 165.438 71.3829Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M161.045 63.3429C159.198 63.5217 158.137 64.964 158.065 66.9189C158.857 65.5722 159.863 64.3642 161.045 63.3429Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M162.923 71.4425C163.394 72.3832 164.202 73.1113 165.187 73.4809C166.481 73.9517 167.16 72.8074 166.826 71.5319C166.522 70.3757 165.485 68.7486 164.174 68.8321C162.863 68.9155 162.35 70.2744 162.923 71.4425Z",
          fill: "#FFB573"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M171.29 67.652C171.35 68.0274 171.606 68.3016 171.851 68.248C172.095 68.1943 172.244 67.8844 172.184 67.5089C172.125 67.1334 171.869 66.8533 171.618 66.9129C171.368 66.9725 171.225 67.2765 171.29 67.652Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M175.564 67.0798C175.623 67.4553 175.874 67.7295 176.124 67.6758C176.374 67.6222 176.517 67.3123 176.458 66.9308C176.398 66.5494 176.142 66.2812 175.892 66.3348C175.641 66.3885 175.498 66.6984 175.564 67.0798Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M174.235 67.4493C174.883 68.5417 175.672 69.5437 176.583 70.4293C176.023 71.1386 174.837 71.0253 174.837 71.0253L174.235 67.4493Z",
          fill: "#ED893E"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M173.466 72.2233C173.025 72.2351 172.586 72.1572 172.176 71.9943C171.767 71.8314 171.394 71.5869 171.082 71.2757C171.062 71.2547 171.051 71.227 171.051 71.1982C171.051 71.1694 171.062 71.1417 171.082 71.1207C171.092 71.1101 171.105 71.1016 171.119 71.0959C171.132 71.0901 171.147 71.0872 171.162 71.0872C171.177 71.0872 171.192 71.0901 171.206 71.0959C171.22 71.1016 171.232 71.1101 171.243 71.1207C171.588 71.4553 172.006 71.7052 172.464 71.8511C172.922 71.9969 173.408 72.0345 173.883 71.9611C173.899 71.9558 173.916 71.9541 173.932 71.9561C173.949 71.958 173.965 71.9636 173.979 71.9724C173.993 71.9812 174.005 71.9931 174.014 72.007C174.023 72.021 174.029 72.0368 174.031 72.0533C174.033 72.0699 174.032 72.0866 174.027 72.1025C174.022 72.1184 174.013 72.133 174.002 72.1453C173.991 72.1575 173.977 72.1671 173.961 72.1734C173.946 72.1797 173.929 72.1825 173.913 72.1816C173.765 72.2072 173.616 72.2211 173.466 72.2233Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M172.274 73.463C171.917 73.2003 171.618 72.8676 171.395 72.4854C171.172 72.1031 171.028 71.6793 170.975 71.2399C170.973 71.2108 170.982 71.1822 171.001 71.16C171.02 71.1378 171.047 71.1237 171.076 71.1207C171.09 71.119 171.105 71.1204 171.119 71.1247C171.133 71.1289 171.146 71.136 171.157 71.1455C171.169 71.155 171.178 71.1667 171.184 71.1799C171.191 71.193 171.194 71.2074 171.195 71.222C171.265 71.6977 171.441 72.1514 171.712 72.5489C171.982 72.9463 172.34 73.2772 172.757 73.5166C172.769 73.5234 172.781 73.5328 172.79 73.544C172.799 73.5553 172.805 73.5683 172.809 73.5822C172.813 73.5961 172.814 73.6107 172.812 73.625C172.81 73.6393 172.806 73.6531 172.798 73.6656C172.791 73.6785 172.781 73.6899 172.769 73.699C172.757 73.7081 172.744 73.7148 172.729 73.7186C172.715 73.7225 172.7 73.7235 172.685 73.7216C172.67 73.7196 172.656 73.7148 172.643 73.7073C172.516 73.6321 172.393 73.5505 172.274 73.463Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M169.735 66.454C169.7 66.4628 169.663 66.4628 169.628 66.454C169.601 66.4408 169.577 66.4223 169.558 66.3997C169.538 66.3771 169.524 66.3508 169.515 66.3224C169.506 66.294 169.503 66.2641 169.506 66.2344C169.509 66.2048 169.518 66.1761 169.532 66.15C169.689 65.8307 169.923 65.5549 170.212 65.347C170.501 65.1391 170.836 65.0055 171.189 64.958C171.219 64.9556 171.248 64.9591 171.276 64.9683C171.304 64.9776 171.33 64.9924 171.352 65.0118C171.375 65.0313 171.393 65.055 171.406 65.0816C171.419 65.1082 171.426 65.1371 171.427 65.1666C171.43 65.1961 171.426 65.2257 171.417 65.2538C171.408 65.2818 171.393 65.3078 171.374 65.33C171.354 65.3522 171.33 65.3703 171.304 65.3832C171.277 65.3961 171.248 65.4035 171.219 65.405C170.945 65.4443 170.685 65.5487 170.46 65.7094C170.235 65.8702 170.051 66.0826 169.926 66.3288C169.909 66.366 169.883 66.3976 169.849 66.4198C169.815 66.442 169.775 66.4539 169.735 66.454Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M177.149 65.3693C177.113 65.3704 177.077 65.3622 177.044 65.3455C177.012 65.3288 176.985 65.3042 176.964 65.274C176.806 65.0344 176.594 64.8346 176.346 64.6899C176.098 64.5452 175.82 64.4596 175.534 64.4396C175.481 64.4309 175.433 64.4036 175.398 64.3627C175.363 64.3217 175.344 64.2698 175.344 64.2161C175.344 64.1623 175.363 64.1104 175.398 64.0694C175.433 64.0285 175.481 64.0012 175.534 63.9926C175.891 64.0126 176.239 64.1157 176.549 64.2937C176.86 64.4716 177.124 64.7195 177.322 65.0177C177.339 65.0415 177.351 65.0684 177.358 65.0969C177.364 65.1255 177.365 65.155 177.36 65.1839C177.355 65.2127 177.344 65.2403 177.329 65.265C177.313 65.2896 177.292 65.3109 177.268 65.3276C177.234 65.3542 177.192 65.3689 177.149 65.3693Z",
          fill: "#263238"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M156.116 87.171C154.924 88.1424 153.667 89.2212 152.469 90.2761C151.271 91.331 150.049 92.4158 148.893 93.5243C146.592 95.6536 144.438 97.9355 142.444 100.354L141.765 101.237L141.681 101.35C141.699 101.323 141.715 101.295 141.729 101.266C141.765 101.2 141.795 101.13 141.818 101.058C141.864 100.938 141.888 100.811 141.89 100.682C141.89 100.48 141.854 100.48 141.89 100.575C141.916 100.758 141.968 100.937 142.045 101.105C142.285 101.668 142.585 102.204 142.939 102.703C143.349 103.305 143.791 103.886 144.262 104.443C145.221 105.635 146.294 106.773 147.421 107.9C148.547 109.026 149.739 110.165 150.877 111.208L150.955 111.273C151.457 111.724 151.77 112.349 151.831 113.021C151.893 113.693 151.697 114.364 151.285 114.898C150.873 115.433 150.274 115.792 149.608 115.903C148.942 116.014 148.259 115.87 147.695 115.499C144.705 113.604 141.91 111.418 139.351 108.973C138.701 108.323 138.063 107.644 137.438 106.893C136.761 106.079 136.162 105.203 135.65 104.276C135.339 103.707 135.086 103.108 134.893 102.488C134.633 101.654 134.54 100.777 134.619 99.9075C134.667 99.3625 134.792 98.8269 134.988 98.3162C135.091 98.0517 135.212 97.7947 135.352 97.5473L135.566 97.1957L135.662 97.0526L136.436 95.9024C138.502 93.0191 140.8 90.3101 143.308 87.8027C144.5 86.563 145.752 85.3532 147.021 84.185C148.291 83.0168 149.548 81.8904 150.949 80.7461C151.81 80.2363 152.825 80.0527 153.81 80.2289C154.794 80.405 155.683 80.9291 156.314 81.7057C156.944 82.4822 157.275 83.4595 157.245 84.4594C157.216 85.4593 156.828 86.4153 156.152 87.1531L156.116 87.171Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.2",
          d:
            "M156.116 87.171C154.924 88.1424 153.667 89.2212 152.469 90.2761C151.271 91.331 150.049 92.4158 148.893 93.5243C146.592 95.6536 144.438 97.9355 142.444 100.354L141.765 101.237L141.681 101.35C141.699 101.323 141.715 101.295 141.729 101.266C141.765 101.2 141.795 101.13 141.818 101.058C141.864 100.938 141.888 100.811 141.89 100.682C141.89 100.48 141.854 100.48 141.89 100.575C141.916 100.758 141.968 100.937 142.045 101.105C142.285 101.668 142.585 102.204 142.939 102.703C143.349 103.305 143.791 103.886 144.262 104.443C145.221 105.635 146.294 106.773 147.421 107.9C148.547 109.026 149.739 110.165 150.877 111.208L150.955 111.273C151.457 111.724 151.77 112.349 151.831 113.021C151.893 113.693 151.697 114.364 151.285 114.898C150.873 115.433 150.274 115.792 149.608 115.903C148.942 116.014 148.259 115.87 147.695 115.499C144.705 113.604 141.91 111.418 139.351 108.973C138.701 108.323 138.063 107.644 137.438 106.893C136.761 106.079 136.162 105.203 135.65 104.276C135.339 103.707 135.086 103.108 134.893 102.488C134.633 101.654 134.54 100.777 134.619 99.9075C134.667 99.3625 134.792 98.8269 134.988 98.3162C135.091 98.0517 135.212 97.7947 135.352 97.5473L135.566 97.1957L135.662 97.0526L136.436 95.9024C138.502 93.0191 140.8 90.3101 143.308 87.8027C144.5 86.563 145.752 85.3532 147.021 84.185C148.291 83.0168 149.548 81.8904 150.949 80.7461C151.81 80.2363 152.825 80.0527 153.81 80.2289C154.794 80.405 155.683 80.9291 156.314 81.7057C156.944 82.4822 157.275 83.4595 157.245 84.4594C157.216 85.4593 156.828 86.4153 156.152 87.1531L156.116 87.171Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M151.783 112.191L155.836 114.67L150.657 117.621C150.657 117.621 147.212 115.046 148.684 113.383L150.413 112.191C150.617 112.058 150.855 111.988 151.098 111.988C151.341 111.988 151.579 112.058 151.783 112.191Z",
          fill: "#FFB573"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M156.057 119.2L153.828 120.511C153.673 120.603 153.502 120.663 153.324 120.688C153.146 120.713 152.965 120.701 152.792 120.655C152.618 120.608 152.456 120.527 152.315 120.416C152.173 120.306 152.055 120.168 151.968 120.011L150.657 117.627L155.836 114.676L156.67 117.656C156.753 117.945 156.738 118.254 156.627 118.533C156.516 118.812 156.315 119.047 156.057 119.2Z",
          fill: "#FFB573"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M194.826 77.1105L200.316 76.0317C198.808 78.6899 201.025 81.2348 203.015 82.8321C203.963 83.595 203.296 84.9598 201.823 85.2161L198.247 85.9194C193.932 86.7895 194.826 77.1105 194.826 77.1105Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M192.645 77.5337L205.233 75.096C207.198 74.7042 208.929 73.5501 210.045 71.8859C211.162 70.2218 211.575 68.183 211.193 66.2156C210.798 64.2516 209.643 62.5232 207.98 61.4069C206.316 60.2905 204.279 59.8767 202.312 60.2556L189.731 62.7231C187.766 63.1191 186.038 64.2751 184.921 65.9394C183.805 67.6038 183.392 69.6416 183.771 71.6094C184.172 73.5663 185.329 75.286 186.991 76.3951C188.652 77.5042 190.684 77.9134 192.645 77.5337Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.3",
          d:
            "M192.645 77.5337L205.233 75.096C207.198 74.7042 208.929 73.5501 210.045 71.8859C211.162 70.2218 211.575 68.183 211.193 66.2156C210.798 64.2516 209.643 62.5232 207.98 61.4069C206.316 60.2905 204.279 59.8767 202.312 60.2556L189.731 62.7231C187.766 63.1191 186.038 64.2751 184.921 65.9394C183.805 67.6038 183.392 69.6416 183.771 71.6094C184.172 73.5663 185.329 75.286 186.991 76.3951C188.652 77.5042 190.684 77.9134 192.645 77.5337Z",
          fill: "white"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M226.903 80.1024L205.447 79.8163C203.588 80.1799 198.891 56.1015 200.727 55.7379L220.478 47.3939L226.903 80.1024Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M221.98 64.0759C223.768 73.1112 225.956 80.2871 226.903 80.1023C227.851 79.9176 227.183 72.4378 225.407 63.4143C223.631 54.3909 221.432 47.2031 220.484 47.3879C219.537 47.5726 220.21 55.0346 221.98 64.0759Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          opacity: "0.3",
          d:
            "M221.98 64.0759C223.768 73.1112 225.956 80.2871 226.903 80.1023C227.851 79.9176 227.183 72.4378 225.407 63.4143C223.631 54.3909 221.432 47.2031 220.484 47.3879C219.537 47.5726 220.21 55.0346 221.98 64.0759Z",
          fill: "black"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M230.056 62.9615C229.621 60.7503 224.692 59.8503 223.649 60.0589C222.606 60.2675 222.099 62.2224 222.529 64.4336C222.958 66.6447 224.168 68.2659 225.217 68.0632C226.265 67.8606 230.473 65.1667 230.056 62.9615Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M263.245 57.2247L235.328 61.7413L235.43 62.3709L263.347 57.8543L263.245 57.2247Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M244.143 45.1712L232.696 54.9309L233.11 55.4162L244.557 45.6565L244.143 45.1712Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M249.81 75.3536L249.598 75.955L253.797 77.4367L254.009 76.8354L249.81 75.3536Z",
          fill: "#56AF79"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M234.599 70.1715L234.396 70.7761L245.019 74.3389L245.222 73.7342L234.599 70.1715Z",
          fill: "#56AF79"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }